import client from '../../base-api';

const serviceURL = '/portal/private-coaching';

const portalPrivateCoachingService = {

    // 1. FIRST INTERVIEW ---
    getFirstInterviewData(coachingId: number) {
        return client.get(`${serviceURL}/first-interview/${coachingId}`);
    },

    // First interview (Regular)
    createFirstInterview(data: any) {
        return client.post(`${serviceURL}/first-interview-create`, data);
    },
    updateFirstInterview(data: any, firstInterviewId: number) {
        return client.put(`${serviceURL}/first-interview-update/${firstInterviewId}`, data);
    },
    updateAsAdminFirstInterview(data: any, firstInterviewId: number) {
        return client.put(`${serviceURL}/first-interview-update-as-admin/${firstInterviewId}`, data);
    },

    // First interview (GO Work a mobile operation type)
    createGoWorkMobileFirstInterview(data: any) {
        return client.post(`${serviceURL}/go-work-mobile-first-interview-create`, data);
    },
    updateGoWorkMobileFirstInterview(data: any, firstInterviewId: number) {
        return client.put(`${serviceURL}/go-work-mobile-first-interview-update/${firstInterviewId}`, data);
    },
    updateAsAdminGoWorkMobileFirstInterview(data: any, firstInterviewId: number) {
        return client.put(`${serviceURL}/go-work-mobile-first-interview-update-as-admin/${firstInterviewId}`, data);
    },

    // First interview (MIC operation type)
    // V1
    createMICFirstInterview(data: any) {
        return client.post(`${serviceURL}/mic-first-interview-create`, data);
    },
    updateMICFirstInterview(data: any, firstInterviewId: number) {
        return client.put(`${serviceURL}/mic-first-interview-update/${firstInterviewId}`, data);
    },
    updateAsAdminMICFirstInterview(data: any, firstInterviewId: number) {
        return client.put(`${serviceURL}/mic-first-interview-update-as-admin/${firstInterviewId}`, data);
    },

    // V2
    createMICFirstInterviewV2(data: any) {
        return client.post(`${serviceURL}/mic-first-interview-v2-create`, data);
    },
    updateMICFirstInterviewV2(data: any, firstInterviewId: number) {
        return client.put(`${serviceURL}/mic-first-interview-v2-update/${firstInterviewId}`, data);
    },
    updateAsAdminMICFirstInterviewV2(data: any, firstInterviewId: number) {
        return client.put(`${serviceURL}/mic-first-interview-v2-update-as-admin/${firstInterviewId}`, data);
    },


    // 2. PROTOCOL ---
    // Common
    getProtocolList(coachingId: number) {
        return client.get(`${serviceURL}/protocol-list/${coachingId}`);
    },
    getProtocolData(id: number) {
        return client.get(`${serviceURL}/protocol/${id}`);
    },
    postProtocolNote(noteData: any) {
        return client.post(`${serviceURL}/protocol-note-create`, noteData);
    },
    putProtocolNote(noteData: any, protocolId: number) {
        return client.put(`${serviceURL}/protocol-note-update/${protocolId}`, noteData);
    },
    protocolDelete(protocolId: number) {
        return client.delete(`${serviceURL}/protocol-delete/${protocolId}`);
    },


    // Protocol (Regular)
    postRegularProtocol(protocolData: any) {
        return client.post(`${serviceURL}/protocol-create`, protocolData);
    },
    updateRegularProtocol(protocolData: any, protocolId: number) {
        return client.put(`${serviceURL}/protocol-update/${protocolId}`, protocolData);
    },
    updateAsAdminRegularProtocol(protocolData: any, protocolId: number) {
        return client.put(`${serviceURL}/protocol-update-as-admin/${protocolId}`, protocolData);
    },


    // Protocol (Go work mobile)
    postGoWorkMobileProtocol(protocolData: any) {
        return client.post(`${serviceURL}/go-work-mobile-protocol-create`, protocolData);
    },
    updateGoWorkMobileProtocol(protocolData: any, protocolId: number) {
        return client.put(`${serviceURL}/go-work-mobile-protocol-update/${protocolId}`, protocolData);
    },
    updateAsAdminGoWorkMobileProtocol(protocolData: any, protocolId: number) {
        return client.put(`${serviceURL}/go-work-mobile-protocol-update-as-admin/${protocolId}`, protocolData);
    },

    // Protocol (MIC) V1
    postMICProtocol(protocolData: any) {
        return client.post(`${serviceURL}/mic-protocol-create`, protocolData);
    },
    updateMICProtocol(protocolData: any, protocolId: number) {
        return client.put(`${serviceURL}/mic-protocol-update/${protocolId}`, protocolData);
    },
    updateUpdateAsAdminMICProtocol(protocolData: any, protocolId: number) {
        return client.put(`${serviceURL}/mic-protocol-update-as-admin/${protocolId}`, protocolData);
    },

    // Protocol (MIC) V2
    postMICV2Protocol(protocolData: any) {
        return client.post(`${serviceURL}/mic-v2-protocol-create`, protocolData);
    },
    updateMICV2Protocol(protocolData: any, protocolId: number) {
        return client.put(`${serviceURL}/mic-v2-protocol-update/${protocolId}`, protocolData);
    },
    updateAsAdminMICV2Protocol(protocolData: any, protocolId: number) {
        return client.put(`${serviceURL}/mic-v2-protocol-update-as-admin/${protocolId}`, protocolData);
    },

    // Meeting data history list
    getMeetingDataHistoryList(meetingId: number) {
        return client.get(`${serviceURL}/meeting-history/${meetingId}`);
    },


    // 3. INVITATION TO FIRST APPOINTMENT
    getInvitationsList(coachingId: number) {
        return client.get(`${serviceURL}/invitation-to-first-appointment-list/${coachingId}`);
    },
    getInvitation(invitationId: number) {
        return client.get(`${serviceURL}/invitation-to-first-appointment/${invitationId}`);
    },
    putInvitation(invitationData: any, invitationId: number) {
        return client.put(`${serviceURL}/invitation-to-first-appointment-update/${invitationId}`, invitationData);
    },
    postInvitation(invitationData: any) {
        return client.post(`${serviceURL}/invitation-to-first-appointment-create`, invitationData);
    },
    invitationDelete(invitationId: number) {
        return client.delete(`${serviceURL}/invitation-to-first-appointment-delete/${invitationId}`);
    },


    // 4. INTERIM REPORT
    getInterimReportList(coachingId: number) {
        return client.get(`${serviceURL}/interim-report-list/${coachingId}`);
    },
    getInterimReport(invitationId: number) {
        return client.get(`${serviceURL}/interim-report/${invitationId}`);
    },
    putInterimReport(invitationData: any, invitationId: number) {
        return client.put(`${serviceURL}/interim-report-update/${invitationId}`, invitationData);
    },
    postInterimReport(invitationData: any) {
        return client.post(`${serviceURL}/interim-report-create`, invitationData);
    },
    deleteInterimReport(invitationId: number) {
        return client.delete(`${serviceURL}/interim-report-delete/${invitationId}`);
    },


    // 5. FINAL INTERVIEW
    getFinalInterviewData(coachingId: number) {
        return client.get(`${serviceURL}/final-interview/${coachingId}`);
    },
    putFinalInterview(formData: any, coachingId: number) {
        return client.put(`${serviceURL}/final-interview-update/${coachingId}`, formData);
    },
    postFinalInterview(formData: any) {
        return client.post(`${serviceURL}/final-interview-create`, formData);
    },


    // 6. INTRODUCTORY DOCUMENTS
    getIntroductoryDocumentsData(coachingId: number) {
        return client.get(`${serviceURL}/introductory-documents/${coachingId}`);
    },
    putIntroductoryDocuments(formData: any, coachingId: number) {
        return client.put(`${serviceURL}/introductory-documents-update/${coachingId}`, formData);
    },
    postIntroductoryDocuments(formData: any) {
        return client.post(`${serviceURL}/introductory-documents-create`, formData);
    },


    // 7. MEETING LIST
    getMeetingList(coachingId: number, filterData: any) {
        return client.get(`${serviceURL}/meeting-list/${coachingId}`, {params: filterData});
    },


    // 8. MODULE LIST AND DETAILS
    getModuleList(coachingId: number) {
        return client.get(`${serviceURL}/module-list/${coachingId}`);
    },


    // 9. MEETING HISTORY
    revertMeetingHistory(meetingType: string, meetingId: number, historyId: number) {
        return client.put(`${serviceURL}/revert-meeting-history/${meetingType}/${meetingId}/${historyId}`);
    },


    //---------------------------------------------------------------------------

    // Digital signature
    saveDigitalSignature(data: any) {
        return client.post(`${serviceURL}/digital-signature`, data);
    },


    // ON DROPDOWN CHANGE (Important !!!!!!!)
    getCompassDateRange(id: number, meetingId = '') {
        return client.get(`${serviceURL}/compass-get-date-range/${id}/${meetingId}`);
    },
    checkIsLastMeetingSystemAddedMeeting(coachingId: number, date: string, meetingId = '') {
        if (!Number.isFinite(coachingId)) {
            return Promise.reject(new Error('Invalid coachingId'));
        }
        return client.get(`${serviceURL}/check-is-last-meeting-system-added-meeting/${coachingId}/${date}/${meetingId}`);
    },
    getSumUnitsDoneForModule(id: number, moduleId: number, meetingId = '') {
        return client.get(`${serviceURL}/get-sun-units-for-module/${id}/${moduleId}/${meetingId}`);
    },
    getGoalsOnChangeModuleOrGoal(moduleId: number, goalId = '') {
        return client.get(`${serviceURL}/get-module-goals-data/${moduleId}/${goalId}`);
    },
    checkMeetingPresenceOnChange(data: any) {
        return client.post(`${serviceURL}/check-meeting-presence`, data);
    },
    getGoalFromLastMeeting(data: any) {
        return client.post(`${serviceURL}/get-goals-from-last-meeting`, data);
    },


    // REMOTE DIGITAL SIGNATURE
    createAccessTokenRemoteDigitalSignature(data: any) {
        return client.post(`${serviceURL}/generate-access-token`, data);
    },
    getRemoteMeetings(token: string) {
        return client.get(`${serviceURL}/remote-meetings/${token}`);
    },
    saveRemoteDigitalSignature(data: any) {
        return client.post(`${serviceURL}/remote/digital-signature`, data);
    },


}

export default portalPrivateCoachingService;